export enum UserBookmarkUrl {
  base = '/user-bookmark{/id}',
  list = '/user-bookmark/list',
}
